export default __webpack_public_path__ + "static/media/1427.a837dad0.png";